import { BehaviorSubject } from 'rxjs';

export default class TemplateRepository {
  tags$ = new BehaviorSubject([]);

  constructor({ templateService, materialService }) {
    this.templateService = templateService;
    this.materialService = materialService;
  }

  async getTags() {
    const tags = await this.materialService.getTags();
    this.tags$.next(tags.data);
  }

  getTemplates(payload) {
    return this.templateService.getTemplates(payload);
  }

  createTemplate(payload) {
    return this.templateService.createTemplate(payload);
  }

  updateTemplate(id, payload) {
    return this.templateService.updateTemplate(id, payload);
  }

  deleteTemplate(id) {
    return this.templateService.deleteTemplate(id);
  }

  getTemplateById(id) {
    return this.templateService.getTemplateById(id);
  }
}
